import Fade from '@mui/material/Fade';
import MuiTooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';
import { styled } from '@mui/material/styles';

import React from 'react';

const HtmlTooltip = styled(({ className, ...props }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <MuiTooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'inherit',
    color: 'inherit',
    maxWidth: 280,
    fontSize: theme.typography.pxToRem(12),
    border: 'initial',
    padding: 'unset',
  },
}));

function Tooltip({
  children,
  content,
  placement = 'bottom',
  zoom = false,
  fade = false,
  arrow = false,
}) {
  const transition = React.useMemo(() => {
    if (!!zoom && !fade) {
      return { TransitionComponent: Fade, TransitionProps: { timeout: 600 } };
    }

    if (!!fade && !zoom) {
      return { TransitionComponent: Zoom };
    }

    if ((!!fade && !!zoom) || (!fade && !zoom)) {
      return {};
    }

    return {};
  }, [zoom, fade]);
  return (
    <HtmlTooltip
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...transition}
      placement={String(placement)}
      title={content}
      arrow={Boolean(arrow)}
      PopperProps={{ keepMounted: true }}
    >
      {children}
    </HtmlTooltip>
  );
}

export default Tooltip;
